export class Material {
  keyID: number;
  name: string;
  description: string;
  stdUM: string;
  subLocationName?: string;
  qtyOnHand?: number;
}
